export function openGoogleMaps(address) {
  if (!address) return;
  const encoded = encodeURIComponent(address);
  const url = `https://www.google.com/maps/search/?api=1&query=${encoded}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
